import React from 'react';
import { bool } from 'prop-types';
import LongFilterPlain from './LongFilterPlain';
import LongFilterPopup from './LongFilterPopup';

const LongFilter = props => {
  const { showAsPopup, ...rest } = props;
  return showAsPopup ? <LongFilterPopup {...rest} /> : <LongFilterPlain {...rest} />;
};

LongFilter.defaultProps = {
  showAsPopup: false,
};

LongFilter.propTypes = {
  showAsPopup: bool,
};

export default LongFilter;
